module.exports = __webpack_public_path__ + "static/media/iconSectionOthers.a47307e4.svg";